import { PaymentFragmentLiability } from '../../pay/models/payment-fragment-liability.model';

export class CartState {
  public paymentId: string;
  public counter: number;
  public totalAmount: number;
  public paymentFragments: PaymentFragmentLiability[];
  public checkedList: CheckedLiabilities;
  public newAmount: number;
}

export interface CheckedLiabilities {
  checkedLiabilities: CheckedLiability[];
  checkedLiabilitiesAmount: number;
}

export interface CheckedLiability {
  id: string;
  amountToPay: number;
}
